import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa73934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "mt-8 justify-items-stretch block relative" }
const _hoisted_7 = { class: "aspect-square w-96" }
const _hoisted_8 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_9 = ["href", "innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "bg-white border-project border-4 rounded-sm flex flex-col relative max-w-4xl" }
const _hoisted_12 = { class: "flex flex-row items-end" }
const _hoisted_13 = { class: "p-4 pb-12" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "justify-end items-end flex-col flex h-full relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/gograss/grasspopup.png",
    class: "w-full"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_puzzle_board = _resolveComponent("puzzle-board")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: "text-3xl font-medium",
              innerHTML: _ctx.$rt(_ctx.config.title, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mt-4",
                  innerHTML: _ctx.$rt(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_puzzle_board, {
                  showNumber: _ctx.showNumbers,
                  cols: 3,
                  rows: 3,
                  src: _ctx.config.image1 ?? _ctx.image,
                  animation: _ctx.animation,
                  width: 300,
                  height: 300,
                  onFinish: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showNumbers = false; _ctx.answer('done')})
                }, null, 8, ["showNumber", "src", "animation"])
              ])
            ]),
            _createVNode(_component_BackNextButtons, {
              colorClass: "green-button mt-8",
              "go-to": _ctx.next,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-3 h-full min-h-50vh flex-col items-center flex",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover;  background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
          }, null, 4)
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_10))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Modal, {
          modelValue: _ctx.showModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showModal = false; _ctx.answer('skip')}),
                class: "absolute top-2 right-4 text-project font-bold text-3xl text-right"
              }, " × "),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.config.popupTexts, (text) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: text,
                      class: "mt-8",
                      innerHTML: _ctx.$rt(text, {name: _ctx.state.nickname.value})
                    }, null, 8, _hoisted_14))
                  }), 128)),
                  _createVNode(_component_ActionButton, {
                    text: "buttons.next",
                    "button-class": "action-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.answer('skip')))
                  })
                ]),
                _hoisted_15
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}